export default __webpack_public_path__ + "static/media/DOM-NOV2025.82bc0365.png";